// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_21cRm","noDisplayLink":"_24yTM"};